/**
 * Open the native OS share sheet for a link (iMessage / WhatsApp / etc.),
 * falling back to copying it to the clipboard when the Web Share API isn't
 * available — which is most desktop browsers.
 *
 * Returns "shared" if the OS sheet handled it (or the user dismissed it), or
 * "copied" if it fell back to the clipboard, so the caller can show feedback.
 */
export async function shareLink(url: string, title: string): Promise<"shared" | "copied"> {
  if (typeof navigator !== "undefined" && typeof navigator.share === "function") {
    try {
      await navigator.share({ title, url });
      return "shared";
    } catch (err) {
      // User dismissed the sheet — respect that, don't also copy.
      if (err instanceof Error && err.name === "AbortError") return "shared";
      // Any other failure: fall through to clipboard.
    }
  }
  try {
    await navigator.clipboard.writeText(url);
  } catch {
    /* ignore */
  }
  return "copied";
}
